module.exports = __webpack_public_path__ + "static/media/BLUSH_8000.0e228095.jpg";